import type { FC, HTMLAttributes, PropsWithChildren, ReactNode } from "react";
import "./Card.css";
import cn from "classnames";

type Props = {
	headerContent?: ReactNode;
	footerContent?: ReactNode;
} & PropsWithChildren &
	HTMLAttributes<HTMLDivElement>;

const Card: FC<Readonly<Props>> = ({
	headerContent,
	children,
	footerContent,
	className,
	...rest
}) => {
	return (
		// TODO replace class with card when bootstrap card is deprecated
		<div className={cn("ncard", className)} {...rest}>
			{children}
		</div>
	);
};

type CardHeaderProps = {} & PropsWithChildren & HTMLAttributes<HTMLElement>;

const CardHeader: FC<Readonly<CardHeaderProps>> = ({ children, ...rest }) => {
	return <header {...rest}>{children}</header>;
};

type CardBodyProps = {} & PropsWithChildren & HTMLAttributes<HTMLDivElement>;

const CardBody: FC<Readonly<CardBodyProps>> = ({
	children,
	className,
	...rest
}) => {
	return (
		<div className={`body${className ? ` ${className}` : ""}`} {...rest}>
			{children}
		</div>
	);
};

type CardFooterProps = {} & PropsWithChildren & HTMLAttributes<HTMLDivElement>;

const CardFooter: FC<Readonly<CardFooterProps>> = ({ children, ...rest }) => {
	return <footer {...rest}>{children}</footer>;
};

const CardNamespace = Object.assign(Card, {
	Header: CardHeader,
	Body: CardBody,
	Footer: CardFooter,
});

export { CardNamespace as Card };
